<!--  -->
<template>
  <div class="cus-modal">
    <div style="display: flex;justify-content: center;align-items: center;">
      <span style="margin-right: 8px;">折扣比例: </span>
      <InputNumber
        style="width: 130px;"
        :max="100"
        precision="4"
        :regx="/^\d*\.{0,1}\d{0,4}$/"
        v-model="ratio"
        :formatter="value => `${value}%`"
        :parser="value => value.replace('%', '')"></InputNumber>
    </div>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      ratio: '',
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.determine();
            }, // 按钮点击事件
          }
        ],
      },
    }
  },
  props: {
    componentData: {
      type: Object,
    }
  },
  methods: {
    async determine() {
      if (!this.ratio) return $fcWarn({ content: t('折扣比例不能为空！') })
      const params = {
        ratio: this.ratio,
        ...this.componentData
      }
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/ratio/modify', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.autoRefresh()
        }
      })
    },
  }
}
</script>
